import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { toast } from "sonner";

const StatCard = ({ label, value, suffix, testid }) => (
  <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-7" data-testid={testid}>
    <p className="text-xs tracking-[0.2em] uppercase text-slate-500">{label}</p>
    <p className="mt-3 text-3xl sm:text-4xl font-display text-white">
      {value}{suffix && <span className="text-[#D4AF37] text-2xl">{suffix}</span>}
    </p>
  </div>
);

const TopList = ({ title, items, testid }) => (
  <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-7" data-testid={testid}>
    <h3 className="text-lg text-white font-display">{title}</h3>
    {items?.length ? (
      <ul className="mt-5 space-y-3">
        {items.map((i) => (
          <li key={i.name} className="flex items-center justify-between gap-4">
            <span className="text-slate-300 text-sm truncate">{i.name}</span>
            <span className="text-[#D4AF37] font-medium text-sm shrink-0">{i.count}</span>
          </li>
        ))}
      </ul>
    ) : (
      <p className="mt-5 text-sm text-slate-500">No data yet</p>
    )}
  </div>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => toast.error("Could not load stats"));
  }, []);

  if (!stats) return <AdminLayout title="Dashboard"><div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" /></AdminLayout>;

  return (
    <AdminLayout title="Dashboard">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="stats-grid">
        <StatCard label="Total Members" value={stats.total_members} testid="stat-total-members" />
        <StatCard label="New Today" value={stats.new_today} testid="stat-new-today" />
        <StatCard label="Active Members" value={stats.active_members} testid="stat-active-members" />
        <StatCard label="Returning Members" value={stats.returning_members} testid="stat-returning-members" />
        <StatCard label="Arriving This Month" value={stats.arriving_this_month} testid="stat-arriving-this-month" />
        <StatCard label="Flights Booked" value={stats.flights_booked_pct} suffix="%" testid="stat-flights-booked" />
        <StatCard label="Accommodation Booked" value={stats.accommodation_booked_pct} suffix="%" testid="stat-accommodation-booked" />
        <StatCard label="Signup Sources" value={stats.sources.length} testid="stat-sources-count" />
      </div>
      <div className="mt-6 grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        <TopList title="Most Popular Universities" items={stats.top_universities} testid="top-universities" />
        <TopList title="Most Popular UK Cities" items={stats.top_uk_cities} testid="top-uk-cities" />
        <TopList title="Most Popular Indian Cities" items={stats.top_indian_cities} testid="top-indian-cities" />
        <TopList title="Main Goals Selected" items={stats.goals} testid="top-goals" />
        <TopList title="Signup Sources" items={stats.sources} testid="top-sources" />
      </div>
    </AdminLayout>
  );
}
